import { createSelector } from 'reselect';
import { reduxKey } from './constants';

const getSlice = state => state[reduxKey];

export const getPopover = createSelector(
  getSlice,
  (_, id) => id,
  (state, id) => {
    const popover = state.find(item => item.id === id);
    if (popover) {
      return {
        isOpen: true,
        params: popover.options.params,
      };
    } else {
      return {
        isOpen: false,
      };
    }
  }
);
